// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__352rg","wrapper":"LoginForm_wrapper__1NhSB","input":"LoginForm_input__mTxl1","label":"LoginForm_label__GzoCm","perdeu":"LoginForm_perdeu__Kramt"};